import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { LockerService } from './lockers.service';

export const Ng1LockerModule = angular
  .module('control-room.shared.services.kitchen', [])
  .factory('crLockerService', downgradeInjectable(LockerService));
